import Image from 'next/image';
import React from 'react';

import { ShopProps } from '@/pages/solucoes-de-pagamentos-digitais';

import { Container, FeatureItem, ImageContainer, Wrapper } from './styles';

export type FeaturesProps = Omit<ShopProps['featureCards'], 'id' | 'referId'>;

const Features: React.FC<{ cards: FeaturesProps }> = ({ cards }) => {
  return (
    <Container colorValue="50">
      <Wrapper>
        {cards.map(({ title, description, ImageResponsive }) => (
          <FeatureItem key={title}>
            <ImageContainer>
              <Image
                src={ImageResponsive.web.path}
                alt={ImageResponsive?.web.alternativeText}
                width="64"
                height="64"
              />
            </ImageContainer>
            <h3 className="heading-3">{title}</h3>
            <h4>{description}</h4>
          </FeatureItem>
        ))}
      </Wrapper>
    </Container>
  );
};

export default Features;
